import {isGeneratingAtom} from '@/components/ChatSection/states'

interface UseMessagesOptions {
  onStopGenerating?: MemoizedCallback<(isActive: boolean) => void>
  onStartGenerating?: MemoizedCallback<() => void>
}

export default function useStopGenerating({
  onStopGenerating,
  onStartGenerating,
}: UseMessagesOptions) {
  const store = useStore()
  const [, startTransition] = useTransition()
  const [isGenerating, setIsGenerating] = useAtom(isGeneratingAtom)
  const stopGenerating = useRef<symbol>(null)
  const latestOnStopGenerating = useLatest(onStopGenerating)

  const shouldStopThisGenerate = useCallback((messageKey: symbol) => {
    return stopGenerating.current !== messageKey
  }, [])

  // Stop generate everything except messageKey
  const stopGenerate = useCallback(
    (
      except: symbol | SyntheticEvent = Symbol('default reason'),
      isActive: boolean = true,
      reason?: string,
    ) => {
      console.debug('Will stop all generating except', except, 'because', reason)
      if (typeof except === 'symbol') {
        stopGenerating.current = except
      } else {
        stopGenerating.current = Symbol(reason)
      }
      setIsGenerating(false)
      startTransition(() => {
        latestOnStopGenerating.current?.(isActive)
      })
    },
    [setIsGenerating],
  )

  const startGenerate = useCallback(() => {
    setIsGenerating(true)
    startTransition(() => {
      onStartGenerating?.()
    })
  }, [onStartGenerating, setIsGenerating])

  const getIsGenerating = useCallback(() => {
    return store.get(isGeneratingAtom)
  }, [store])

  return {isGenerating, getIsGenerating, shouldStopThisGenerate, stopGenerate, startGenerate}
}
